import { emptyHthFace, generalHthHelper } from '@monorepo/helpers';
import { FC, useState } from 'react';
import { Hr } from '@/components/_commons';
import { HTHFaceBuildingsAddModalComplex } from './HTHSectionFaceBuildingsAddModalComplex';
import { HTHFaceBuildingsAddModalSimple } from './HTHSectionFaceBuildingsAddModalSimple';
import { HTHLocateFaceFromAddress } from '@/components/_commons/house-to-house/HTHLocateFaceFromAddress';
import { Modal } from 'react-bootstrap';
import { typeHTHFace, typeTerritoryNumber } from '@monorepo/models';
import { useGetConfig, useGetIsDarkMode } from '@/custom-hooks';

type propsType = {
    closeModal: () => void;
    currentFace: typeHTHFace | null;
    territoryNumber: typeTerritoryNumber | null;
};

// Common

export const HTHFaceBuildingsAdd: FC<propsType> = ({ closeModal, currentFace, territoryNumber }) => {
    const [face, setFace] = useState<typeHTHFace | null>(currentFace && territoryNumber ?
        {
            ...emptyHthFace,
            block: currentFace.block,
            face: currentFace.face,
            street: currentFace.street,
            territoryNumber
        }
        :
        null
    );
    const [showComplex, setShowComplex] = useState(false);
    const [streetNumber, setStreetNumber] = useState(0);
    const [streetNumber2, setStreetNumber2] = useState(0);
    const [streetNumber3, setStreetNumber3] = useState(0);
    const config = useGetConfig();
    const isDarkMode = useGetIsDarkMode();

    const closeHTHModalHandler = () => {
        closeModal();
        setShowComplex(false);
        setStreetNumber(0);
    }

    return (
        <Modal
            backdrop={'static'}
            backdropClassName={isDarkMode ? 'bg-dark': ''}
            contentClassName={isDarkMode ? 'bg-dark text-white' : ''}
            fullscreen={showComplex || undefined}
            keyboard={false}
            onHide={closeHTHModalHandler}
            show
            size={showComplex ? undefined : 'xl'}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    AGREGAR EDIFICIO
                </Modal.Title>
            </Modal.Header>
            {face ?
                <Modal.Body>
                    {!currentFace &&  // only for location by address
                        <>
                        <Modal.Title>
                            {face.territoryNumber ? `Territorio ${face.territoryNumber}` : ''}
                        </Modal.Title>
                        <Modal.Title>
                            {face.territoryNumber ? `Manzana ${generalHthHelper.MaskTheBlock(face.block || '', config.isUsingLettersForBlocks)}` : ''}
                        </Modal.Title>
                        <Modal.Title>
                            {face.territoryNumber ? `Cara "${generalHthHelper.MaskTheFace(face.face || '', config.isUsingLettersForBlocks)}": ${face?.street}` : ''}
                        </Modal.Title>
                        <Hr />
                        </>
                    }
                    {showComplex ?
                        <HTHFaceBuildingsAddModalComplex
                            closeHTHModalHandler={closeHTHModalHandler}
                            currentFace={currentFace ?? {
                                ...emptyHthFace,
                                ...face
                            }}
                            setShowComplex={setShowComplex}
                            setStreetNumber={setStreetNumber}
                            setStreetNumber2={setStreetNumber2}
                            setStreetNumber3={setStreetNumber3}
                            streetNumber={streetNumber}
                            streetNumber2={streetNumber2}
                            streetNumber3={streetNumber3}
                            territoryNumber={face.territoryNumber!}
                        />
                        :
                        <HTHFaceBuildingsAddModalSimple
                            closeHTHModalHandler={closeHTHModalHandler}
                            currentFace={currentFace ?? {
                                ...face,
                                buildings: [],
                                coordsPoint1: { lat: 0, lng: 0 },
                                coordsPoint2: { lat: 0, lng: 0 },
                                coordsPoint3: { lat: 0, lng: 0 },
                                doNotCalls: [],
                                id: 0,
                                observations: [],
                                serviceDates: []
                            }}
                            setShowComplex={setShowComplex}
                            setStreetNumber={setStreetNumber}
                            setStreetNumber2={setStreetNumber2}
                            setStreetNumber3={setStreetNumber3}
                            streetNumber={streetNumber}
                            streetNumber2={streetNumber2}
                            streetNumber3={streetNumber3}
                            territoryNumber={face.territoryNumber!}
                        />
                    }
                </Modal.Body>
                :
                <Modal.Body>
                    <HTHLocateFaceFromAddress
                        setValues={(f, sn) => {
                            setFace(f);
                            setStreetNumber(sn);
                        }}
                        values={{
                            face,
                            streetNumber
                        }}
                    />
                </Modal.Body>
            }
        </Modal>
    );
}
